module.exports = "<nav class=\"navbar navbar-expand-md navbar-dark bg-dark\">\n  <a class=\"navbar-brand\" href=\"#\">Password Manager Online - oldwildweb.com {{testo}}</a>\n  <div class=\"collapse navbar-collapse\" id=\"navbarsExampleDefault\">\n    <ul class=\"navbar-nav mr-auto\">\n      <li class=\"nav-item\">\n        <a class=\"nav-link\" href=\"http://www.oldwildweb.com/\"> Back to home page</a>\n      </li>\n    </ul>\n  </div>\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/header/header.component.html
// module id = ./src/app/template/header/header.component.html
// module chunks = main